import React from 'react';
import styled from '@emotion/styled';
import { CheckCircle2, ChevronRight, Lock } from 'lucide-react';

/**
 * TaskCard — one task in a list on /me: icon, name, a line under it, and on
 * the right where it stands (open, done, locked). The pre-work list and the
 * homework list draw their tasks with it. Pure: text in, onClick out.
 */
const Button = styled.button`
  all: unset; cursor: ${(p) => (p.disabled ? 'default' : 'pointer')}; box-sizing: border-box; width: 100%;
  background: #141821; border: 1px solid #232a36; border-radius: 10px; padding: 1.1rem 1.35rem;
  display: flex; align-items: center; gap: 1rem; opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  &:hover, &:focus-visible { border-color: ${(p) => (p.disabled ? '#232a36' : '#3a4457')}; }
`;
const IconWrap = styled.div`
  flex: 0 0 auto; width: 2.4rem; height: 2.4rem; border-radius: 8px; display: grid; place-items: center;
  background: rgba(91, 157, 217, 0.14); color: #8ec1f0;
`;
const Text = styled.div`flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 0.15rem; text-align: left; strong { color: #e8e8ef; }`;
const Hint = styled.div`font-size: 0.88rem; color: #9aa4b2; line-height: 1.4;`;
const Done = styled.span`flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; color: #6fd3c8; font-size: 0.85rem; font-weight: 600;`;
const Locked = styled.span`flex: 0 0 auto; display: inline-flex; align-items: center; gap: 0.35rem; color: #7b8794; font-size: 0.85rem;`;
const Chevron = styled(ChevronRight)`flex: 0 0 auto; color: #7b8794;`;

/**
 * @param {{ icon: React.ComponentType, title: string, hint?: string, state?: 'open'|'done'|'locked', doneLabel?: string, lockedLabel?: string, onClick?: () => void }} props
 */
export default function TaskCard({ icon: Icon, title, hint = null, state = 'open', doneLabel = '', lockedLabel = '', onClick }) {
  const disabled = state === 'locked';
  return (
    <Button type="button" disabled={disabled} onClick={() => !disabled && onClick?.()}>
      <IconWrap>{disabled ? <Lock size={20} /> : <Icon size={20} />}</IconWrap>
      <Text><strong>{title}</strong>{hint && <Hint>{hint}</Hint>}</Text>
      {state === 'done' ? <Done><CheckCircle2 size={18} /> {doneLabel}</Done> : state === 'locked' ? <Locked><Lock size={14} /> {lockedLabel}</Locked> : <Chevron size={18} />}
    </Button>
  );
}
